<!--  -->
<template>
  <div class="register-container">
    <Search
      v-model:modelRef="modelRef"
      v-model:pageData="pageData"
      :tableData="tableData"
      :countryData="countryData"
      :loadingObj="loadingObj"
      @resetFields="resetFields($event)"
      @onSubmit="onSubmit($event)"
      @pageChange="pageChange($event)"
      @downloadChange="downloadChange($event)"
      @fetchCountry="fetchCountry($event)"
    ></Search>
  </div>
</template>

<script>
// 导入的其他文件 例如：import moduleName from 'modulePath';
import Search from "./dashboard/search/index.vue";
import { preRegister, download, countryList } from "@/api/index.js";
import { message } from "ant-design-vue";
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  ref,
  watch,
  computed,
  nextTick
} from "vue";
import moment from "moment";
import { useStore } from "vuex";
import { downLoadFile } from "@/utils/index.js";
export default defineComponent({
  //import所引入的组件注册
  setup() {
    // 表单规则
    const store = useStore();
    const formModel = {
      phoneNumber: null,
      time: null,
      country: null,
      method: null,
      lang: null,
      device: null,
      utm_source: null,
      utm_medium: null,
      utm_campaign: null,
      utm_content: null,
      language: "zh"
    };
    const state = reactive({
      gameCode: ""
    });

    let modelRef = ref(JSON.parse(JSON.stringify(formModel)));
    let countryData = ref([]);
    const loadingObj = reactive({
      loadingDownload: false,
      loadingSearch: false,
      loadingReset: false,
      loading: false
    });
    let countryData2 = [];
    // table
    const tableState = reactive({
      tableData: null
    });
    // pagination
    const pageData = reactive({
      current: 1,
      pageSize: 15,
      total: 0,
      filterTotal: 0
    });
    const pageChange = (page, pageSize) => {
      onSubmit();
    };
    // 事件

    // 获取国家列表
    const getCountryList = () => {
      let params = {
        gameCode: state.gameCode
      };
      countryList(params).then(res => {
        if (res.status === 200) {
          countryData.value = res.data.countries;
          countryData2 = res.data.countries;
        }
      });
    };
    const resetFields = searchFrom => {
      if (searchFrom) {
        loadingObj.loadingReset = true;
        setTimeout(() => {
          loadingObj.loadingReset = false;
        }, 500);
      }
      modelRef.value = JSON.parse(JSON.stringify(formModel));
      onSubmit();
    };
    let downloadState = {};
    const onSubmit = e => {
      if (e === "click") {
        loadingObj.loadingSearch = true;
        pageData.current = 1;
      }
      let params = {
        gameCode: state.gameCode,
        pageNumber: pageData.current,
        orderField: "regTime",
        orderType: "desc"
      };
      console.log(modelRef, "modelRef");
      if (modelRef.value.lang) {
        params.language = modelRef.value.lang;
        downloadState.language = modelRef.value.lang;
      }
      if (modelRef.value.phoneNumber) {
        params.user = modelRef.value.phoneNumber;
        downloadState.user = modelRef.value.phoneNumber;
      }
      if (modelRef.value.method) {
        params.userType = modelRef.value.method;
        downloadState.userType = modelRef.value.method;
      }
      if (modelRef.value.time && modelRef.value.time.length > 0) {
        params.beginTime = moment(modelRef.value.time[0]).unix();
        params.endTime = moment(modelRef.value.time[1]).unix();
        downloadState.time = modelRef.value.time;
      }
      if (modelRef.value.country) {
        params.country = modelRef.value.country;
        downloadState.country = modelRef.value.country;
      }
      if (modelRef.value.device) {
        params.device = modelRef.value.device;
        downloadState.device = modelRef.value.device;
      }
      if (modelRef.value.utm_source) {
        params.utmSource = modelRef.value.utm_source;
        downloadState.utmSource = modelRef.value.utm_source;
      }
      if (modelRef.value.utm_campaign) {
        params.utmCampaign = modelRef.value.utm_campaign;
        downloadState.utmCampaign = modelRef.value.utm_campaign;
      }
      if (modelRef.value.utm_medium) {
        params.utmMedium = modelRef.value.utm_medium;
        downloadState.utmMedium = modelRef.value.utm_medium;
      }
      if (modelRef.value.utm_content) {
        params.utmContent = modelRef.value.utm_content;
        downloadState.utmContent = modelRef.value.utm_content;
      }
      loadingObj.loading = true;
      preRegister(params).then(res => {
        if (res.status === 200) {
          pageData.total = res.data.total;
          pageData.filterTotal = res.data.filterTotal;
          res.data.users.forEach(item => {
            item.date = moment(item.regTime * 1000).format(
              "YYYY/MM/DD HH:mm:ss"
            );
          });
          res.data.users.forEach(item => {
            let findLang = store.state.settings.languages.find(
              itemR => itemR.fullCode == item.language
            );
            if (findLang) {
              item.language = findLang.name;
            }
          });
          tableState.tableData = res.data.users;
          setTimeout(() => {
            loadingObj.loading = false;
            loadingObj.loadingSearch = false;
          }, 2000);
        }
      });
    };
    const downloadChange = () => {
      loadingObj.loadingDownload = true;
      let params = {
        gameCode: state.gameCode,
        pageNumber: pageData.current
      };
      if (downloadState.lang) {
        params.language = downloadState.lang;
      }
      if (downloadState.phoneNumber) {
        params.user = downloadState.phoneNumber;
      }
      if (downloadState.method) {
        params.userType = downloadState.method;
      }
      if (downloadState.method) {
        params.userType = downloadState.method;
      }
      if (downloadState.time && downloadState.time.length > 0) {
        params.beginTime = moment(downloadState.time[0]).unix();
        params.endTime = moment(downloadState.time[1]).unix();
        params.orderField = "regTime";
        params.orderType = "desc";
      }
      if (downloadState.country) {
        params.country = downloadState.country;
      }
      if (downloadState.device) {
        params.device = downloadState.device;
      }
      if (downloadState.utm_source) {
        params.utmSource = downloadState.utm_source;
      }
      if (downloadState.utm_campaign) {
        params.utmCampaign = downloadState.utm_campaign;
      }
      if (downloadState.utm_medium) {
        params.utmMedium = downloadState.utm_medium;
      }
      if (downloadState.utm_content) {
        params.utmContent = downloadState.utm_content;
      }
      download(params).then(res => {
        if (res.status === 200) {
          downLoadFile(res.data, state.gameCode);
          nextTick(() => {
            message.success("下载成功");
            loadingObj.loadingDownload = false;
          });
        }
      });
    };
    const fetchCountry = value => {
      value = value.toLowerCase();
      let data = [];
      data = countryData2.filter(item => {
        let text = [item.countryName, item.countryCode, item.countryPublishName]
          .join("【】")
          .toLowerCase();
        return text.indexOf(value) > -1;
      });
      countryData.value = data;
    };
    let currentGameCodeRef = computed(
      () => store.state.settings.currentGamgeCode
    );
    let loadingRef = computed(() => store.state.settings.loading);
    watch(
      [currentGameCodeRef, loadingRef],
      ([currentGameCode, loading], [preCurrentGameCode, preLoading]) => {
        if (currentGameCode) {
          state.gameCode = currentGameCode;
          resetFields();
          getCountryList();
        }
      }
    );
    watchEffect(() => {
      if (store.state.settings.currentGamgeCode) {
        state.gameCode = store.state.settings.currentGamgeCode;
      }
    });
    return {
      modelRef,
      resetFields,
      onSubmit,
      downloadChange,
      pageChange,
      pageData,
      countryData,
      fetchCountry,
      loadingObj,
      ...toRefs(tableState),
      ...toRefs(state)
    };
  },
  name: "search",
  components: {
    Search
  }
});
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.register-container {
  margin-top: 80px;
}
</style>